const { Button } = require("reactstrap");

function orderColumns(handleEdit, handleDelete,isAdmin) {
  return [
    {
      Header: "order_id",
      accessor: "id",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Order Date",
      accessor: "date_of_order",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => {
        let formattedDate = "-";
        if (value) {
          const date = new Date(value);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          formattedDate = `${day}-${month}-${year}`;
        }
        return (
          <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
            {formattedDate}
          </span>
          );
        },
    },
    {
      Header: "Customer Name",
      accessor: "name",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Vehicle No",
      accessor: "vehicle_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Phone no",
      accessor: "phone_no",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => <span>{value ? value : "-"}</span>,
    },
    {
      Header: "Proof",
      accessor: "proof",
      disableSortBy: true,
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => {
        if (!value) return <span>No Image</span>;
        const baseUrl = process.env.REACT_APP_API_URL.replace(/\/api$/, '');
        console.log('baseUrl', baseUrl)
        const imageURL = `${baseUrl}/${value}`;
        return (
          <div style={{ width: "50px", height: "50px" }} className="proof-img-hover">
            <img 
              src={imageURL} 
              alt="Proof" 
              style={{ 
                width: "100%", 
                height: "100%", 
                objectFit: "cover",
                cursor: "pointer"
              }}
              onClick={(e) => {
                e.preventDefault();
                const newWindow = window.open();
                newWindow.document.write(`
                  <html>
                    <head>
                      <title>Order Proof</title>
                      <style>
                        body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #f5f5f5; }
                        img { max-width: 100%; max-height: 100%; object-fit: contain; }
                      </style>
                    </head>
                    <body>
                      <img src="${imageURL}" alt="Order Proof" />
                    </body>
                  </html>
                `);
              }}
            />
          </div>
        );
      },
    },   
    {
      Header: "Total Qty (ltr)",
      accessor: "total_qty",
      disableFilters: true,
      filterable: false,
    },
    ...(isAdmin ? [
    {
      Header: "Total Price",
      accessor: "total_price",
      disableFilters: true,
      filterable: false,
    },     
    {
      Header: "Status",
      accessor: "order_status",
      disableSortBy: true,
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => <span>{value}</span>,
    },
    ] : []),
    ...(isAdmin && (handleEdit || handleDelete)
      ? [
          {
            Header: "Actions",
            accessor: "actions",
            disableFilters: true,
            filterable: false,
            Cell: ({ row }) => (
              <>
                {handleEdit && (
                  <Button
                    color="primary"
                    size="sm"
                    className="me-2"
                    onClick={() => handleEdit(row.original)}
                  >
                    Update
                  </Button>
                )}
                {handleDelete && (
                  <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(row.original)}
                  >
                    Delete
                  </Button>
                )}
              </>
            ),
          },
        ]
      : []),
  ];
}

export default orderColumns;
